import React from 'react';
import Popup from 'reactjs-popup';
import cc from 'classcat';

const InfoTooltip = props => {
    return (
        <Popup
            trigger={_ => (
                <div className={cc(['info-tooltip__icon', props.className])}>
                    <img src="/assets/icons/info.png" alt="" />
                </div>
            )}
            // Fallback positions + keepTooltipInside so tooltips near the right/bottom
            // edge (e.g. the last card in a row) flip instead of overflowing off-screen.
            position={['bottom left', 'bottom right', 'top left', 'top right']}
            keepTooltipInside
            closeOnDocumentClick
            on={['hover', 'focus']}
            className="info-tooltip"
            arrow={false}
            id="tooltip"
        >
            <span>{props.tooltip}</span>
        </Popup>
    );
};

export default InfoTooltip;
